import { render, staticRenderFns } from "./suspensao.vue?vue&type=template&id=82c4062a"
import script from "./suspensao.vue?vue&type=script&lang=js"
export * from "./suspensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports